import { render, staticRenderFns } from "./SelectPadrao.vue?vue&type=template&id=b6db7c12&lang=pug"
import script from "./SelectPadrao.vue?vue&type=script&lang=js"
export * from "./SelectPadrao.vue?vue&type=script&lang=js"
import style0 from "./SelectPadrao.vue?vue&type=style&index=0&id=b6db7c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports